import { axiosInstance } from "@/api/apiClient";
import {
  CallLogsApi,
  CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetailRequest,
  CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogsRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new CallLogsApi(undefined, BASE_API, axiosInstance);

export const getBusinessCallLogs = async (
  payload: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogsRequest
) => {
  return api.telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogs.bind(
    api
  )(payload);
};

export const getBusinessCallLogDetails = async (
  payload: CallLogsApiTelephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetailRequest
) => {
  return api.telephonyViewsNinjaCallCallLogBusinessGetBusinessCallLogDetail.bind(
    api
  )(payload);
};
